/* Before/After Slider — Tabbed slider + rotating reviews (matches headless) */
(function() {
  'use strict';

  /* ---------- Tab Switching ---------- */
  var tabs = document.querySelectorAll('[data-ba-tab]');
  var sliders = document.querySelectorAll('[data-ba-slider]');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var idx = tab.getAttribute('data-ba-tab');
      tabs.forEach(function(t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      sliders.forEach(function(s) {
        s.classList.toggle('is-active', s.getAttribute('data-ba-index') === idx);
      });
    });
  });

  /* ---------- BA Slider Interaction ---------- */
  sliders.forEach(function(slider) {
    var before = slider.querySelector('.ba-slider__before');
    var handle = slider.querySelector('.ba-slider__handle');
    var isDragging = false;
    var position = 50;

    function setPosition(pct) {
      pct = Math.max(5, Math.min(95, pct));
      position = pct;
      before.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    }

    function getPercent(clientX) {
      var rect = slider.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    slider.addEventListener('mousedown', function(e) {
      isDragging = true;
      setPosition(getPercent(e.clientX));
    });
    window.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      setPosition(getPercent(e.clientX));
    });
    window.addEventListener('mouseup', function() { isDragging = false; });

    slider.addEventListener('touchstart', function(e) {
      isDragging = true;
      setPosition(getPercent(e.touches[0].clientX));
    }, { passive: true });
    slider.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      setPosition(getPercent(e.touches[0].clientX));
    }, { passive: true });
    slider.addEventListener('touchend', function() { isDragging = false; });

    /* Auto-animate */
    var autoRaf;
    var dir = 1;
    var cycleCount = 0;
    var pauseUntil = 0;

    function autoAnimate() {
      if (isDragging) { autoRaf = requestAnimationFrame(autoAnimate); return; }
      var now = Date.now();
      if (now < pauseUntil) { autoRaf = requestAnimationFrame(autoAnimate); return; }

      var distToEdge = dir > 0 ? 90 - position : position - 10;
      var ease = distToEdge < 15 ? 0.3 + 0.7 * (distToEdge / 15) : 1;
      position += dir * 1.2 * ease;

      if (position >= 90) {
        position = 90;
        dir = -1;
        pauseUntil = now + 600;
      }
      if (position <= 10) {
        position = 10;
        dir = 1;
        cycleCount++;
        pauseUntil = now + 600;
        if (cycleCount >= 2) {
          cycleCount = 0;
          /* Auto-switch to next tab after 2 cycles */
          setTimeout(function() {
            var activeTab = document.querySelector('[data-ba-tab].is-active');
            if (activeTab) {
              var nextIdx = (parseInt(activeTab.getAttribute('data-ba-tab')) + 1) % tabs.length;
              var nextTab = document.querySelector('[data-ba-tab="' + nextIdx + '"]');
              if (nextTab) nextTab.click();
            }
          }, 700);
        }
      }
      setPosition(position);
      autoRaf = requestAnimationFrame(autoAnimate);
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          autoRaf = requestAnimationFrame(autoAnimate);
        } else {
          cancelAnimationFrame(autoRaf);
        }
      });
    }, { threshold: 0.3 });

    observer.observe(slider);
    setPosition(50);
  });

  /* ---------- Rotating Reviews ---------- */
  function setupReviewRotation(container, dotSelector) {
    if (!container) return;
    var reviews = container.querySelectorAll('.rotating-review');
    var dots = container.querySelectorAll(dotSelector || '[data-review-dot]');
    if (reviews.length <= 1) return;

    var current = 0;

    function showReview(idx) {
      reviews[current].classList.remove('is-active');
      if (dots.length) dots[current].classList.remove('is-active');
      current = idx % reviews.length;
      reviews[current].classList.add('is-active');
      if (dots.length) dots[current].classList.add('is-active');
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        showReview(parseInt(dot.getAttribute('data-review-dot')));
      });
    });

    setInterval(function() {
      showReview(current + 1);
    }, 10000);
  }

  /* Desktop reviews */
  var desktopReviews = document.querySelector('[data-rotating-reviews]');
  if (desktopReviews) {
    setupReviewRotation(desktopReviews.closest('.ba-reviews-col'), '[data-review-dot]');
  }

  /* Mobile reviews */
  var mobileReviews = document.querySelector('[data-rotating-reviews-mobile]');
  if (mobileReviews) {
    setupReviewRotation(mobileReviews, '[data-review-dot]');
  }
})();
